import { Products } from "../types/products.js";
const TAMEENI_PRODUCT_LINKS = {
  [Products.CAR]: "https://qcmotor.gettameeni.com",
  [Products.HEALTH_SME]: "https://qcmotor.gettameeni.com",
  [Products.MEDICAL_MALPRACTICE]: "https://qcmotor.gettameeni.com",
  [Products.HEALTH_INDIVIDUAL]: "https://qcmotor.gettameeni.com",
  [Products.TRAVEL]: "https://qcmotor.gettameeni.com",
  [Products.FLEET_SME]: "https://qcmotor.gettameeni.com",
  [Products.PROTECTION_AND_SAVING]: "https://qcmotor.gettameeni.com",
  [Products.MARINE]: "https://qcmotor.gettameeni.com",
  [Products.HOME]: "https://qcmotor.gettameeni.com"
};
export {
  TAMEENI_PRODUCT_LINKS
};
